// Bundle leggero per il frontend (missconvenienza.it)
// NON include: Summernote, Select2, Bootstrap-select, jQuery UI, Bootbox, admin.js

try {
  const jq = require('jquery');
  const j = jq.default || jq;
  window.$ = window.jQuery = global.$ = global.jQuery = j;
} catch (e) {
  console.error('[app-front.js] jQuery load error', e);
}

require('popper.js/dist/umd/popper.js');
require('bootstrap');

require('bootstrap-select');
require('bootstrap-select/js/i18n/defaults-it_IT');

import './script-front';
